import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

export const MUTATION = graphql(`
  mutation CreateHappyHour($input: CreateOnlineOrderHappyHourInput!, $timeRuleInput: CreateMenuSectionTimeRule!) {
    createHappyHour(input: $input, timeRuleInput: $timeRuleInput) {
      id
      deliveryType
      discountType
      discountAmount
      minimumOrderAmount
      isActive

      timeRule {
        __typename
        ... on MenuSectionAlwaysTimeRule {
          type
        }

        __typename
        ... on MenuSectionRangeTimeRule {
          type
          start
          end
          daysOfWeek
          isAllDays
        }
      }
    }
  }
`);

export default function useCreateHappyHour() {
  return useMutation(MUTATION, {
    refetchQueries: ['GetHappyHours', 'GetHappyHour'],
  });
}
